export default "__VITE_ASSET__Crbk206Y__"